/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `s1` - s1
 * * `u1` - u1
 * @export
 */
export const SavedStateVariableEnum = {
  S1: "s1",
  U1: "u1",
} as const;
export type SavedStateVariableEnum =
  (typeof SavedStateVariableEnum)[keyof typeof SavedStateVariableEnum];

export function instanceOfSavedStateVariableEnum(value: any): boolean {
  for (const key in SavedStateVariableEnum) {
    if (Object.prototype.hasOwnProperty.call(SavedStateVariableEnum, key)) {
      if (SavedStateVariableEnum[key as keyof typeof SavedStateVariableEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SavedStateVariableEnumFromJSON(json: any): SavedStateVariableEnum {
  return SavedStateVariableEnumFromJSONTyped(json, false);
}

export function SavedStateVariableEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SavedStateVariableEnum {
  return json as SavedStateVariableEnum;
}

export function SavedStateVariableEnumToJSON(value?: SavedStateVariableEnum | null): any {
  return value as any;
}

export function SavedStateVariableEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SavedStateVariableEnum {
  return value as SavedStateVariableEnum;
}
